// Render in the browser; server-side rendering is disabled.
export const ssr = false;

// Accept URLs with or without a trailing slash.
export const trailingSlash = 'ignore';
